import * as React from "react";

const Seccion = ({ classes, title, info = [] }) => {
  return (
    <div className={classes.seccionInfo}>
      {title && <div className={classes.labelTitle}>{title}</div>}
      <div className={classes.infoList}>
        {info.map(({ title, value, styledTitle }, key) => (
          <div key={key} className={classes.infoLabel}>
            <lable className={styledTitle ? classes.label : ""}>{title}</lable>
            {` ${value}`}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Seccion;
